module.exports = __webpack_public_path__ + "statics/img/1-2.b4afbca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/1-2.png
// module id = 0HiO
// module chunks = 1